// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import archiveIcon from "@/assets/icons/archive.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type ArchiveIconProps = Omit<IconProps, "name">;

export function ArchiveIcon(props: ArchiveIconProps): React.ReactNode {
  return <Icon name={archiveIcon} {...props} />;
}
